export function preloadImage(src: string): Promise<void> {
  return new Promise(resolve => {
    const img = new window.Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = src;
  });
}
